import { DefaultTheme } from 'styled-components';

// COME SI LEGGE UNA RIGA, NEI DUE ALBERI (utente, 2026-10-15; prototipo, ds.css `.row`, `.tree-block`).
// Lo Scene Editor e il Composer disegnano le righe con componenti loro, ma i segni sono questi e
// stanno qui, perché due copie dello stesso arancio divergono alla prima modifica.
//
// - LA RIGA SCELTA: fondo arancio lavato e un filo arancio intorno.
// - LE RIGHE CHE LA CONTENGONO (la «scia»): lo stesso lavato, senza filo; il glifo e la freccetta
//   prendono l'arancio. Scegliere un figlio non spegne i padri: si vede ancora dove sta.
// - LA CARD, SOLO NEL COMPOSER (prototipo: `.tree-block` lo crea solo Logics; utente, 2026-10-20): un
//   attributo con le sue opzioni, o un'area, è una card grigia, testata compresa. Nello Scene Editor le
//   righe stanno direttamente sul pannello.

/** Il lavato della riga scelta e della sua scia. */
export const treeRowWash = (theme: DefaultTheme) => `${theme.app.secondary}14`;
/** Il filo della sola riga scelta. */
export const treeRowRing = (theme: DefaultTheme) => `inset 0 0 0 1px ${theme.app.secondary}`;
/** Il glifo e la freccetta di una riga della scia: l'arancio da testo, non quello pieno (prototipo `--accent-text`). */
export const treeTrailInk = (theme: DefaultTheme) => `var(--editor-accent-text, ${theme.app.secondary})`;
/** Il fondo della card di un attributo nel Composer, e quello della riga che si trascina. */
export const TREE_CARD_BACKGROUND = 'var(--editor-sunken, #e9ebed)';
export const TREE_CARD_RADIUS = '8px';

// LA COLONNA DELL'INSPECTOR È GRIGIA (utente, 2026-10-15; prototipo `.inspector { background: var(--bg-sunken) }`):
// testata, tab, corpo e stato vuoto. Bianche restano le card e i campi, col loro bordo; bianco resta
// l'albero. Un posto solo per i due editor.
export const INSPECTOR_BACKGROUND = 'var(--editor-sunken, #e9ebed)';

// LA MARCA IN TESTATA ALL'INSPECTOR (prototipo `--ident-thumb`; utente, 2026-10-20): il riquadro col glifo
// della specie, grigio come la colonna e staccato da un filo. Cinquantasei pixel in tutti e due gli editor,
// per oggetti, materiali, luci, camere, Look, attributi e opzioni: la testata ha un'altezza sola, qualunque
// cosa sia scelta.
export const INSPECTOR_MARK_SIZE = 56;
export const INSPECTOR_MARK_GLYPH = 24;
export const INSPECTOR_MARK_RADIUS = '8px';
export const INSPECTOR_MARK_LINE = 'var(--editor-line, #d1d3d8)';
